import { PackageStatus } from '@allocab/allocab-dedicated-driver-types/lib/src/dedicated-package/types';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { DriverTripPackageCard } from './DriverTripPackageCard';
import { PrimaryButton } from '../../components/button/PrimaryButton';
import { SideBarTripPackageFilter } from '../../components/layout/side-bar/SideBarTripPackageFilter';
import { Spinner } from '../../components/Spinner';
import { useInfiniteFetchTripPackagesByDriverKey } from '../../hooks/useFetchTripPackagesByDriverKey';
import { t } from '../../services/translation/translation';
import { STATUS_SEARCH_PARAMS_KEY } from '../_authenticated._main.trips.trip-package/TripPackageStatusFilter';

const tableStatus = ['ACCEPTED', 'CANCELLED', 'DRAFT', 'IN_PROGRESS', 'PROPOSED', 'TERMINATED'];

type Props = {
  driverKey: string;
};

export const DriverTripPackageCards = ({ driverKey }: Props) => {
  const [searchParams] = useSearchParams();
  const direction = (searchParams.get('direction') ?? 'desc') as 'desc' | 'asc';
  const orderBy = searchParams.get('orderBy') ?? 'startDate';
  const status = (searchParams.get(STATUS_SEARCH_PARAMS_KEY)?.split(',') ?? tableStatus) as PackageStatus[];

  const { data, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage } = useInfiniteFetchTripPackagesByDriverKey(
    driverKey,
    {
      direction,
      orderBy,
      status,
    },
  );

  const trippackages = useMemo(() => data?.pages.map(p => p.items).flat() || [], [data]);

  return (
    <div>
      <SideBarTripPackageFilter />
      <div className="space-y-2">
        {trippackages.map(trippackage => (
          <DriverTripPackageCard key={trippackage.id} trippackage={trippackage} />
        ))}
      </div>

      <div>
        {hasNextPage ? (
          <div className="flex justify-center mt-3">
            <PrimaryButton
              onClick={() => {
                fetchNextPage();
              }}
              isLoading={isFetchingNextPage}
            >
              {t('common.see-more')}
            </PrimaryButton>
          </div>
        ) : null}
        <div>{isLoading ? <Spinner /> : null}</div>
      </div>
    </div>
  );
};
